import { useIsMutating } from "@tanstack/react-query";

export const useIsCloningResource = ({
  resource,
  id,
  locale,
}: {
  resource: string;
  id: string;
  locale?: string;
}) => {
  const count = useIsMutating({
    mutationKey: [resource, "clone", id],
    predicate: (mutation) => {
      if (locale) {
        return mutation.state.variables.locale === locale;
      }
      return true;
    },
  });

  return count > 0;
};
